{
  "title": "Fly",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level transmutation",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a wing feather from any bird)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You touch a willing creature. The target gains a flying speed of 60 feet for the duration. When the spell ends, the target falls if it is still aloft, unless it can stop the fall.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, you can target one additional creature for each slot level above 3rd."
  ],
  "spellLists": ["artificer", "sorcerer", "warlock", "wizard"]
}
